<template>
  <div class="content-section">
    <v-row>
      <v-col cols="12" md="6">
        <div class="template-type-section">
          <h4 class="subsection-title">Template Type</h4>
          <div class="modern-toggle">
            <button
              v-for="(templateType, i) in messageTypes"
              :key="i"
              class="toggle-option"
              :class="{ 'active': templateType.valid }"
              @click="setSelectedMessageType(templateType)">
              {{ templateType.label }}
            </button>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="!isSmsActive">
      <v-col cols="12">
        <v-text-field
          v-model="form.subjectLine"
          validate-on-blur
          label="Subject"
          class="line-input custom-filled"
          dense
          hide-details="auto"
          :rules="[rules.required, rules.max255]" />
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="!isSmsActive" @click="goToEmailEditor" class="email-preview">
        <div class="preview-label">Email Body Preview (Click to edit)</div>
        <div class="preview-content" v-html="form.body" />
      </v-col>
      <v-col v-if="isSmsActive">
        <v-textarea
          outlined
          rows="10"
          name="smsBody"
          label="SMS Message Body"
          class="line-input"
          v-model="form.body"
          hide-details="auto" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ValidateService from '../../../../_services/ValidateService';

export default {
  name: 'MessageContent',
  props: ['pageData'],
  components: {},
  data() {
    return {
      form: {
        messageType: 'email/html',
        subjectLine: '',
        enabled: true,
        body: '&lt;Click here to go to email editor&gt;',
      },
      isSmsActive: false,
      messageTypes: [
        {
          label: 'Email',
          type: 'email/html',
          valid: true,
        },
        {
          label: 'SMS',
          type: 'sms/text',
          valid: false,
        },
      ],
      rules: ValidateService.validators,
    };
  },
  watch: {
    ['pageData.parent']: {
      handler() {
        this.setupParentRelationship();
      },
      deep: false,
    },
    ['pageData.parent.selectedTemplate']: {
      handler() {
        this.setSelectedTemplate();
      },
      deep: false,
    },
  },
  methods: {
    setupParentRelationship() {
      // eslint-disable-next-line
      this.pageData.parent.contentTab = this; // hack
    },
    setSelectedTemplate() {
      const { selectedTemplate } = this.pageData.parent;
      this.updateMessageTypeValidity(selectedTemplate.type);
      this.form.messageType = selectedTemplate.type;
      this.form.subjectLine = selectedTemplate.subjectLine;
      this.form.body = selectedTemplate.body || '&lt;Click here to go to email editor&gt;';
    },
    setSelectedMessageType(messageType) {
      this.updateMessageTypeValidity(messageType.type);
      this.form.messageType = messageType.type;

      if (messageType.type === 'sms/text' && !this.isValidSmsBody(messageType.type)) {
        this.responseDialogText = 'This template contains html and cannot be converted into an sms.';
        this.isResponseDialogOpen = true;
      }
    },
    isValidSmsBody() {
      const regex = /<[a-z][\s\S]*>/i;
      return regex.test(this.form.body);
    },
    updateMessageTypeValidity(type) {
      this.messageTypes[0].valid = type === 'email/html' ? true : false;
      this.messageTypes[1].valid = type === 'sms/text' ? true : false;

      this.isSmsActive = type === 'sms/text' ? true : false;
    },
    goToEmailEditor() {
      this.pageData.parent.goToEmailEditor();
    },
    extractKeys(subjectLine, body) {
      const regex = /{{\s*(\w+)\s*}}/g;
      const keys = [];
      let match;

      while ((match = regex.exec(subjectLine)) !== null) {
        if (match[1] !== 'clientUID') {
          keys.push(match[1]);
        }
      }

      while ((match = regex.exec(body)) !== null) {
        if (match[1] !== 'clientUID') {
          keys.push(match[1]);
        }
      }

      return keys;
    },
  },
  mounted() {
    if (this.pageData?.parent) {
      this.setupParentRelationship();

      if (this.pageData.parent.selectedTemplate) {
        this.setSelectedTemplate();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

$subsection-title-color: #374151;
$preview-label-color: #374151;
$preview-border-color: #e2e8f0;
$preview-bg-color: #f8fafc;
$preview-hover-border-color: #cbd5e0;
$preview-hover-bg-color: #f1f5f9;

.content-section {
  padding: 16px 0;
}

.template-type-section {
  margin-bottom: 24px;
}

.subsection-title {
  font-size: 14px;
  font-weight: 600;
  color: $subsection-title-color;
  margin: 0 0 12px 0;
}

.email-preview {
  cursor: pointer;
  
  .preview-label {
    font-size: 14px;
    font-weight: 600;
    color: $preview-label-color;
    margin-bottom: 12px;
  }
  
  .preview-content {
    border: 1px solid $preview-border-color;
    border-radius: 8px;
    padding: 16px;
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
    background-color: $preview-bg-color;
    transition: all 0.2s ease;
    
    &:hover {
      border-color: $preview-hover-border-color;
      background-color: $preview-hover-bg-color;
    }
  }
}
</style>